import { PAGE_TYPE, CLASSIFICATION_TYPE } from "../../constants";
import { eventPagePayloadCreator } from "../../helpers/eventPayloadCreator";
import { EventData, EventPayload } from "../../types";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface GamingPDPPagePayload extends EventPayload {
  products?: {
    name?: string;
    slug?: string;
  };
}

const GamingPDPPageViewedAnalyticsEvent: EventData = {
  pageType: PAGE_TYPE.gaming,
  eventName: "Gaming PDP Viewed",
  classification: CLASSIFICATION_TYPE.experienceEvent,
};

export const createGamingPDPPageViewedPageEventPayload =
  eventPagePayloadCreator<GamingPDPPagePayload>(
    GamingPDPPageViewedAnalyticsEvent,
  );
